<template>
  <div class="basic-manners-package-form-container">
    <form @submit.prevent="onsubmit">
      <va-input
        v-model="name"
        type="text"
        label="Name"
        :error="!!nameErrors.length"
        :error-messages="nameErrors"
      />

      <va-input
        v-model="email"
        type="email"
        label="Email"
        :error="!!emailErrors.length"
        :error-messages="emailErrors"
      />
      <div class="d-flex justify--center mt-3">
        <va-button type="submit">{{sendButtonText}}</va-button>
      </div>
    </form>
  </div>
</template>

<script>

export default {
  name: 'basic-manners-package-form',
  data () {
    return {
      sendButtonText: 'Send',
      toastText: '',
      name: '',
      email: '',
      nameErrors: [],
      emailErrors: [],
    }
  },
  computed: {
    message () {
      return 'Request to enroll in the basic manners package.'
    },
    formReady () {
      return !this.emailErrors.length && !this.nameErrors.length
    },
  },
  methods: {
    onsubmit () {
      this.nameErrors = this.name ? [] : ['Name is required']
      this.emailErrors = this.email ? [] : ['Email is required']
      if (!this.formReady) {
        return
      }
      this.sendButtonText = 'Sending...'
      const mail = new FormData()
      mail.append('name', this.name)
      mail.append('email', this.email)
      mail.append('message', this.message)
      mail.append('subject', 'New Inquiry - Basic Manners Package')
      this.sendMail(mail)
    },
    sendMail (mail) {
      fetch('https://rewarding-dog-training-email.herokuapp.com/sendEmail', {
        method: 'post',
        body: mail,
      }).then((response) => {
        if (response.status === 500) {
          this.toastText = 'An error occured when sending this message'
        } else if (response.status === 200) {
          this.toastText = 'Message Sent'
          this.$emit('sent-request')
        } else {
          this.toastText = 'Please try again'
        }
        this.sendButtonText = 'Send'
        this.launchToast()
      })
        .catch((err) => {
          console.log(err)
          this.toastText = 'An error occured when sending this message'
          this.launchToast()
          this.sendButtonText = 'Send'
        })
    },
    launchToast () {
      this.showToast(
        this.toastText,
        {
          position: 'top-center',
          duration: 4500,
          fullWidth: false,
        },
      )
    },
  },
}
</script>

<style lang="scss">
.basic-manners-package-form-container {
  width: 100%;

  form {
    width: 100%;
    min-width: 300px;
  }
}
</style>
